import axios from "axios";
import AuthService from "./AuthService";

export const publicApi = axios.create({
    baseURL: `${process.env.REACT_APP_WOLF_SERVER}/api`
})

export const token = {
    id: process.env.REACT_APP_TOKEN_ID,
    token: process.env.REACT_APP_TOKEN_CONTENT
};

export const sensorIds = {
    temperature: process.env.REACT_APP_TEMPERATURE_SENSOR_ID,
    water: process.env.REACT_APP_WATER_SENSOR_ID,
    exportFile: process.env.REACT_APP_EXPORT_FILE_ID
}

const api = axios.create({
    baseURL: `${process.env.REACT_APP_WOLF_SERVER}/api`
})

api.interceptors.request.use(
    config => {
        config.headers['authorization'] = localStorage.getItem('authToken')
        return config
    },
    error => Promise.reject(error)
);

api.interceptors.response.use((response) => {
    return response
}, async function (error) {
    const originalRequest = error.config
    if (error.response.status === 403 && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
            await AuthService.login()
            return api(originalRequest);
        } catch (e) {
            return Promise.reject(error)
        }
    }
    return Promise.reject(error)
})

export default api

